import React, { useMemo } from 'react';

import { styled } from '@mui/material/styles';
import { useContainer } from 'unstated-next';

import { AddSessionsFields, AddSessionsFieldsProps } from '../../../../../components/addSessions/AddSessionsFields';
import { AttendanceType } from '../../../../../components/addSessions/types';
import { calcSessions } from '../../../../../components/addSessions/utils/calcSessions';
import { ClassSessionInfo, ClassStudentGroup } from '../../../../../context/types';
import ClassContainer from '../../ClassContainer';

const SessionsContainer = styled('div')`
    margin: 0 0 1rem 0;
`;

interface DateInterface {
    index: number;
    isLastIndex: boolean;
    classGroups?: ClassStudentGroup[] | undefined;
    classSessions?: ClassSessionInfo[] | undefined;
    classSessionGroupUuid?: string;
    label?: string;
    selectedGroups?: string[];
    attendanceType?: AttendanceType;
}

const Date: React.FC<DateInterface> = ({
    isLastIndex,
    index,
    classGroups,
    classSessionGroupUuid,
    label,
    selectedGroups,
    attendanceType
}) => {
    const { control, addDefaultDate, removeDate, dateFields } = useContainer(ClassContainer);

    const date = useMemo(() => dateFields[index], [dateFields, index]);
    const { isOvernight } = useMemo(() => calcSessions(date), [date]);

    const props: AddSessionsFieldsProps = useMemo(() => {
        const values: AddSessionsFieldsProps = {
            namePrefix: `dates.${index}.`,
            control,
            isOvernight,
            classGroups,
            classSessionGroupUuid,
            label,
            selectedGroups,
            attendanceType
        };

        if (isLastIndex) {
            values.onAddMore = addDefaultDate;
        }

        if (index !== 0) {
            values.onClose = () => removeDate(index);
        }

        return values;
    }, [
        addDefaultDate,
        control,
        index,
        isLastIndex,
        isOvernight,
        removeDate,
        classGroups,
        selectedGroups,
        attendanceType,
        classSessionGroupUuid,
        label
    ]);

    return (
        <SessionsContainer>
            <AddSessionsFields {...props} />
        </SessionsContainer>
    );
};

export default Date;
